import { render, staticRenderFns } from "./Offerte.vue?vue&type=template&id=3cde4f6a&scoped=true"
import script from "./Offerte.vue?vue&type=script&lang=js"
export * from "./Offerte.vue?vue&type=script&lang=js"
import style0 from "./Offerte.vue?vue&type=style&index=0&id=3cde4f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cde4f6a",
  null
  
)

export default component.exports